<template>
  <v-app>
    <v-app-bar app color="grey darken-2" dark>
      <img
        src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
        alt="Logo HEIG-VD"
        height="70%"
        class="logo"
      />
      <div class="d-flex align-center ml-5">DEMANDES D'ÉQUIVALENCE</div>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row class="mt-10 mb-0" justify="center">
          <v-col cols="12" sm="12" lg="8" v-if="!readOnly">
            <router-link to="/equivalences?status=pending"
              >À traiter</router-link
            >
            <div class="separator mx-3">|</div>
            <router-link
              to="/equivalences?status=accepted,accepted-partial,rejected,exemption-accepted,exemption-accepted-partial,other,rejected"
              >Historique</router-link
            >
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="12" lg="8"
            ><router-view
              :formatDate="formatDate"
              :isAfterOpening="isAfterOpening"
              :downloadBundle="downloadBundle"
              :downloading="downloading"
              :readOnly="readOnly"
          /></v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";
import { format, parseISO } from "date-fns";
import fileDownload from "js-file-download";
import axios from "axios";

export default {
  name: "App",
  components: { UserProfile },
  mounted() {
    this.readOnly = !this.$keycloak.hasResourceRole(
      "manager",
      process.env.VUE_APP_KC_CLIENT_ID
    );
    console.log(
      this.$keycloak.hasResourceRole(
        "manager-dad",
        process.env.VUE_APP_KC_CLIENT_ID
      )
    );

    if (
      this.$keycloak.hasResourceRole(
        "manager-dad",
        process.env.VUE_APP_KC_CLIENT_ID
      )
    ) {
      this.$router.push(
        "/equivalences?status=accepted,accepted-partial,rejected,exemption-accepted,exemption-accepted-partial,other,rejected"
      );
    }
  },
  data: () => ({
    readOnly: true,
    downloading: false,
  }),
  methods: {
    formatDate: function (value) {
      return format(parseISO(value), "dd.MM.yyyy HH:mm");
    },
    isAfterOpening: function (value) {
      return parseISO(value) >= new Date("2026-09-01T00:00:00+02:00");
    },
    async downloadBundle(_id) {
      this.downloading = _id;
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/manager/equivalences/${_id}?format=pdf`,
        responseType: "arraybuffer",
        timeout: 120000,
      });
      fileDownload(data, "demande-d-equivalence.pdf");
      this.downloading = false;
    },
  },
};
</script>

<style>
.separator {
  display: inline-block;
}
</style>